import { useQuery } from '@tanstack/react-query';
import { IPaymentOption } from '../../types/@types/generated/contentful';
import { Currency } from '../../types/PaymentTypes';
import { getAmountSuggestions } from '../api';

const AMOUNT_SUGGESTIONS = 'AMOUNT_SUGGESTIONS';

export function useAmountSuggestions({
  currency,
  amountConfiguration,
}: {
  currency?: Currency;
  amountConfiguration?:
    | IPaymentOption['fields']['oneTimeAmountConfiguration']
    | IPaymentOption['fields']['subscriptionAmountConfiguration'];
}) {
  const { isInitialLoading: isLoadingAmountSuggestions, data } = useQuery(
    [AMOUNT_SUGGESTIONS, [currency?.code, amountConfiguration]],
    async () => {
      const { result } = await getAmountSuggestions({
        currencyCode: (currency as Currency).code,
        configuration: amountConfiguration,
      });

      return {
        amountSuggestions: result.map((amountSuggestion) => amountSuggestion.amount),
        defaultAmountSuggestion: result.find((amountSuggestion) => amountSuggestion.default)
          ?.amount,
      };
    },
    {
      enabled: Boolean(currency?.code),
    },
  );

  return { ...data, isLoadingAmountSuggestions };
}
